var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHomepageGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.475 4.913C7.174 5.241 7 5.741 7 6.395v23.21c0 .654.174 1.154.485 1.468l.08.07L20.447 18.14v-.29L7.555 4.842l-.08.07Z",
  fill: "url(#homepage_google_svg__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m24.733 22.487-4.297-4.337v-.303l4.297-4.338.093.058 5.083 2.916c1.454.827 1.454 2.193 0 3.03l-5.082 2.917-.094.057Z",
  fill: "url(#homepage_google_svg__b)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m24.827 22.43-4.39-4.431L7.475 31.084c.474.512 1.27.57 2.16.07l15.192-8.724Z",
  fill: "url(#homepage_google_svg__c)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.827 13.567 9.635 4.856c-.89-.513-1.688-.443-2.16.07l12.962 13.072 4.39-4.431Z",
  fill: "url(#homepage_google_svg__d)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.733 22.335 9.644 30.99c-.842.49-1.594.455-2.08.01l-.08.082.08.07c.486.443 1.238.48 2.08-.01l15.193-8.711-.104-.095Z",
  fill: "#000"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.12,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m29.91 19.362-5.19 2.974.094.094 5.082-2.916c.729-.419 1.087-.968 1.087-1.515-.044.502-.415.979-1.074 1.363Z",
  fill: "#000"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.634 5.008 29.91 16.635c.659.374 1.03.863 1.087 1.363 0-.547-.358-1.096-1.087-1.515L9.634 4.856C8.18 4.016 7 4.717 7 6.395v.152c0-1.68 1.18-2.37 2.634-1.54Z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "homepage_google_svg__a",
  x1: 19.292,
  y1: 6.145,
  x2: -1.368,
  y2: 11.598,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.007,
  stopColor: "#00A1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#00BEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.512,
  stopColor: "#00D2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#00DFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00E3FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "homepage_google_svg__b",
  x1: 31.806,
  y1: 17.998,
  x2: 6.646,
  y2: 17.998,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.409,
  stopColor: "#FFBD00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.775,
  stopColor: "orange"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9C00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "homepage_google_svg__c",
  x1: 22.44,
  y1: 20.41,
  x2: 5.643,
  y2: 48.416,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3A44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "homepage_google_svg__d",
  x1: 4.211,
  y1: -2.807,
  x2: 11.704,
  y2: 9.701,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#32A071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.069,
  stopColor: "#2DA771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.476,
  stopColor: "#15CF74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.801,
  stopColor: "#06E775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00F076"
})))));
export default SvgHomepageGoogle;